import { ConfigService } from 'src/app/services/config.service';

export const photo = (face: number, configService: ConfigService) =>
  face && `${configService.apiUrl}/faces/photos/${face}`;
